export default __webpack_public_path__ + "static/media/aa6d2fd5be5972025b538084bd4c44711581602345085.6bc33cf6.webp";